/**
 * Облік незбережених змін без чернетки, спільний для форм (`useUnsavedGuard`) і виходу
 * (`platform/sign-out.ts`, `shell/UserMenu.tsx`). «Вийти» перед запитом до сервера питає людину,
 * якщо хоч одна форма тримає такі зміни (або збереження ще в дорозі); після підтвердженого
 * виходу `beforeunload` форм знімається, щоб браузер не лишив людину на порожній сторінці.
 */
const active = new Set<symbol>();
let released = false;

/** Форма тримає зміни без чернетки чи збереження в дорозі; повертає «відпустити». */
export function trackUnsaved(): () => void {
  const token = Symbol('unsaved');
  active.add(token);
  return () => {
    active.delete(token);
  };
}

/** Хоч одна форма має зміни, яких вихід позбавить людину. */
export const hasUnsavedChanges = (): boolean => active.size > 0;

/** Вихід підтверджено: `beforeunload` форм мовчить (документ іде на вхід). */
export function releaseUnloadGuards(): void {
  released = true;
}

export const unloadReleased = (): boolean => released;

/** Лише для тестів. */
export function resetUnloadGuardsForTests(): void {
  released = false;
  active.clear();
}
